import Axios from 'axios'
import {facilityUrls} from '../urls'
import router from '../../../router'
import { activityUrls } from '../../ActivityService/urls'

export default {
  get_all_facilities (context) {
    Axios.get(facilityUrls.getAllFacilities).then(function (response) {
      context.commit('GET_ALL_FACILITIES', response.data)
    })
  },
  get_active_camping (context) {
    Axios.get(facilityUrls.getActiveCamping).then(function (response) {
      context.commit('GET_ACTIVE_CAMPING', response.data)
    })
  },
  get_active_facilities (context) {
    Axios.get(facilityUrls.getActiveFacilities).then(function (response) {
      context.commit('GET_ACTIVE_FACILITIES', response.data)
    })
  },
  get_inactive_facilities (context) {
    Axios.get(facilityUrls.getInActiveFacilities).then(function (response) {
      context.commit('GET_IN_ACTIVE_FACILITIES', response.data)
    })
  },
  get_active_accommodation (context) {
    Axios.get(facilityUrls.getActiveAccommodation).then(function (response) {
      context.commit('GET_ACTIVE_ACCOMMODATION', response.data)
    })
  },
  get_active_accommodation_campsite (context) {
    Axios.get(facilityUrls.getActiveAccommodationCampsite).then(function (response) {
      context.commit('GET_ACTIVE_ACCOMMODATION_CAMPSITE', response.data)
    })
  },
  post_facility_availability_schedule (context, data) {
    Axios.post(facilityUrls.postFacilityUnavailabilitySchedule, data).then(function (response) {
      context.dispatch('get_facility_availability_schedule', data.facility_id)
      router.push({
        name: 'Facility',
        params: {
          facility_id: data.facility_id
        }
      })
      return response
    }, function () {})
  },
  post_facility_surge_schedule (context, data) {
    Axios.post(facilityUrls.postFacilitySurgeSchedule, data).then(() => {
      context.dispatch('get_facility_surge_schedule', data.facility_id)
      router.push({
        name: 'Facility',
        params: {
          facility_id: data.facility_id
        }
      })
    })
  },
  get_facility_surge_schedule (context, publicId) {
    Axios.get(facilityUrls.getSurgeSchedule + publicId).then(function (response) {
      context.commit('FACILITY_SURGE', response.data)
    })
  },
  get_facility_availability_schedule (context, publicId) {
    Axios.get(facilityUrls.getUnavailabilitySchedule + publicId).then((response) => {
      context.commit('FACILITY_UNAVAILABILITY', response.data)
    })
  },
  edit_facility_availability_schedule (context, data) {
    Axios.patch(facilityUrls.modifyUnavailabilitySchedule, data).then(function (response) {
      context.dispatch('get_facility_availability_schedule', data.facility_id)
    })
  },
  remove_faiclity_surge_schedule (context, publicId) {
    Axios.patch(facilityUrls.deleteSurgeSchedule, {schedule_id: publicId}).then(() => {
      context.dispatch('get_facility_availability_schedule')
      router.push({
        name: 'Facility',
        params: {
          facility_id: publicId
        }
      })
    })
  },
  delete_facility_availability_schedule (context, data) {
    Axios.patch(facilityUrls.deleteUnavailabilitySchedule, data).then((response) => {
      context.dispatch('get_facility_availability_schedule', data.facility_id)
      context.commit('FACILITY_UNAVAILABILITY', response.data)
      router.push({
        name: 'Facility',
        params: {
          facility_id: data.facility_id
        }
      })
    })
  },
  recommend_camping (context, publicId) {
    Axios.get(facilityUrls.recommendCamping + publicId).then(function (response) {
      context.commit('RECOMMENDED_CAMPING', response.data)
    })
  },
  recommend_accommodation (context, publicId) {
    Axios.get(facilityUrls.recommendAccommodation + publicId).then(function (response) {
      context.commit('RECOMMENDED_ACCOMMODATION', response.data)
    })
  },
  make_facility_inactive (context, data) {
    Axios.post(facilityUrls.makeFacilityInactive + data.public_id, data).then(function (response) {
      context.dispatch('get_active_facilities')
    })
  },
  make_facility_active (context, data) {
    Axios.post(facilityUrls.makeFacilityActive + data.public_id, data).then(function (response) {
      context.dispatch('get_inactive_facilities')
      router.push({
        name: 'Facilities'
      })
    })
  },
  get_facilities (context, publicId) {
    Axios.get(facilityUrls.getFacilities + publicId).then(function (response) {
      context.commit('GET_FACILITIES', response.data)
    })
  },
  get_facility_images (context, publicId) {
    Axios.get(facilityUrls.getFacilityImages + publicId).then(function (response) {
      context.commit('GET_FACILITY_IMAGES', response.data)
    }).catch(function () {
      context.commit('GET_FACILITY_IMAGES', [])
    })
  },
  delete_facility_image (context, data) {
    Axios.get(facilityUrls.deleteFacilityImage + data.public_id).then(function (response) {
      context.dispatch('get_facility_images', data.facility_id)
    })
  },
  // delete_thumbnail_facility_image (context, publicId) {
  //   Axios.get(facilityUrls.deleteFacilityThumbnailImage + publicId).then(function (response) {
  //     context.dispatch('get_facility_images', publicId)
  //   })
  // },\
  delete_thumbnail_facility_image (context, publicId) {
    Axios.post(facilityUrls.deleteFacilityThumbnailImage + publicId).then(function (response) {
      context.dispatch('get_facility_images', publicId)
    })
  },
  get_deleted_facilities (context) {
    Axios.get(facilityUrls.getDeletedFacility).then(function (response) {
      context.commit('GET_DELETED_FACILITIES', response.data)
    })
  },
  get_facility (context, publicId) {
    Axios.get(facilityUrls.getFacility + publicId).then(function (response) {
       context.commit('GET_FACILITY', response.data)
    })
  },
  get_facility_with_pricing (context, data) {
    Axios.post(facilityUrls.getFacilityWithPricing + data.public_id, data).then(function (response) {
      context.commit('GET_FACILITY', response.data)
    })
  },

  get_external_facility_with_pricing(context, data) {
    Axios.post(facilityUrls.getExternalFacilityWithPricing + data.public_id, data).then(function (response) {
      context.commit('GET_EXTERNAL_FACILITY', response.data)
  
      
    })
  },
  
  post_facility (context, data) {
    Axios.post(facilityUrls.postFacility, data).then(function () {
      // router.push({
      //   name: 'Facilities'
      // })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  update_facility (context, data) {
    Axios.post(facilityUrls.editFacility + data.public_id, data).then(function () {
     
      router.push({
        name: 'Facility',
        params: {
          facility_id: data.public_id
        }
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
     
    })
  },
  delete_facility (context, data) {
    Axios.post(facilityUrls.deleteFacility + data.facility_id, data).then(function () {
      router.push({
        name: 'Facilities'
      })
    })
  },
  restoreFacility (context, publicId) {
    Axios.get(facilityUrls.restoreFacility + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITIES', response.data)
      router.push({
        name: 'Module.Facilities'
      })
    })
  }
}
